export type TagsProps = {
  tags: string[];
  content: StoreProfilePageContent;
};

export function Tags({ tags, content }: TagsProps) {
  return (
    <div className="flex w-full flex-col items-start">
      <h2 className="text-xl">{content.profile.others}</h2>

      <div className="flex w-full flex-row flex-wrap">
        {tags.map(tag => (
          <span
            key={tag}
            className="ring-store-primary mt-4 mr-4 rounded-lg bg-white px-2 py-1 text-sm whitespace-nowrap ring-1"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
